module.exports = __webpack_public_path__ + "static/media/drop_size_1.40336773.png";